import {
    GET_CUSTOM_TAB,
    GET_CUSTOM_TAB_SUCCESS,
    GET_CUSTOM_TAB_ERROR,
    UPDATE_CUSTOM_TAB,
    UPDATE_CUSTOM_TAB_SUCCESS,
    UPDATE_CUSTOM_TAB_ERROR,
    GET_CUSTOM_SORTED_TAB,
    GET_CUSTOM_SORTED_TAB_SUCCESS,
    GET_CUSTOM_SORTED_TAB_ERROR,
    UPDATE_CUSTOM_SORTED_TAB,
    UPDATE_CUSTOM_SORTED_TAB_SUCCESS,
    UPDATE_CUSTOM_SORTED_TAB_ERROR,
} from "../types";


export const getCustomTab = (canteenId) => ({
    type: GET_CUSTOM_TAB,
    payload: { canteenId },
});

export const getCustomTabSuccess = (customTabData) => ({
    type: GET_CUSTOM_TAB_SUCCESS,
    payload: customTabData,
});

export const getCustomTabError = (error) => ({
    type: GET_CUSTOM_TAB_ERROR,
    payload: error,
});

export const updateCustomTab = (customTabData) => ({
    type: UPDATE_CUSTOM_TAB,
    payload: { customTabData },
});

export const updateCustomTabSuccess = (success, message, customTabData) => ({
    type: UPDATE_CUSTOM_TAB_SUCCESS,
    payload: { success, message, customTabData },
});

export const updateCustomTabError = (error) => ({
    type: UPDATE_CUSTOM_TAB_ERROR,
    payload: error,
});


export const getCustomSortedTab = (canteenId) => ({
    type: GET_CUSTOM_SORTED_TAB,
    payload: { canteenId },
});

export const getCustomSortedTabSuccess = (customSortedTabData) => ({
    type: GET_CUSTOM_SORTED_TAB_SUCCESS,
    payload: customSortedTabData,
});

export const getCustomSortedTabError = (error) => ({
    type: GET_CUSTOM_SORTED_TAB_ERROR,
    payload: error,
});

export const updateCustomSortedTab = (customSortedTabData, callback) => ({
    type: UPDATE_CUSTOM_SORTED_TAB,
    payload: { customSortedTabData, callback },
});

export const updateCustomSortedTabSuccess = (success, message, customSortedTabData) => ({
    type: UPDATE_CUSTOM_SORTED_TAB_SUCCESS,
    payload: { success, message, customSortedTabData },
});

export const updateCustomSortedTabError = (error) => ({
    type: UPDATE_CUSTOM_SORTED_TAB_ERROR,
    payload: error,
});